var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChannelDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B1BECF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.393 19.137c.414 0 .75.336.75.75s-.336.75-.75.75H7.607c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.786zM19 5.25c1.519 0 2.75 1.231 2.75 2.75v6.929c0 1.518-1.231 2.75-2.75 2.75H5c-1.519 0-2.75-1.232-2.75-2.75V8c0-1.519 1.231-2.75 2.75-2.75zm0 1.5H5c-.69 0-1.25.56-1.25 1.25v6.929c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25z",
    transform: "translate(-709 -119) translate(165 90) translate(515 10) translate(29 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelDesktop);
export default __webpack_public_path__ + "static/media/channel-desktop.993023646efc3b0d892dd38e167c58cf.svg";
export { ForwardRef as ReactComponent };